module.exports = __webpack_public_path__ + "img/zyxq.05fe2762.jpg";